import { CONFIG } from "./config.js";

export const apiClient = {
    async post(endpoint, data) {
        try {
            const response = await fetch(`${CONFIG.API_BASE_URL}${endpoint}`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify(data)
            });

            if (!response.ok) throw new Error(`API Error: ${response.status}`);

            return await response.json();
        } catch (error) {
            console.error("Error:", error);
            throw error;
        }
    },

    async generateSpell(rewardData) {
        try {
            console.log(rewardData);
            const generatedSpells = await this.post(CONFIG.ENDPOINTS.GENERATESPELL, rewardData);
            return generatedSpells; 
        } catch (error) {
            console.error("Failed to generate spell in apiClient:", error);
            throw error; 
        }
    }
};